import { Repository } from "../../adapters/repository";
import { DateOps } from "../../adapters/dateOps";
import { present } from "../../../utils/presenter";
import { validateUnAvailability } from "../../entities/unAvailabilityValidator";
import { findError } from "../../../entities/errorChecker";
import { Interactor } from "./types";

function createInteractor(
  repository: Repository,
  dateOps: DateOps,
): Interactor {
  return ({ unavailability, nextUnavailability }) => {
    const error = validateUnAvailability(dateOps, nextUnavailability);

    return present(
      !findError(error)
        ? repository
            .updateUnavailability(unavailability, nextUnavailability)
            .catch((e) =>
              Promise.reject({
                unavailability,
                nextUnavailability,
                error: { ...error, ...e },
              }),
            )
        : Promise.reject({ nextUnavailability, unavailability, error }),
    );
  };
}

export type { Interactor };

export { createInteractor };
